import { BASE_URL, COUNTRY_CODE } from "@utils/constants";
import axios from "axios";

export async function updateUserLanguage(locale: string, access_token: string) {
  try {
    await axios.put(
      `${BASE_URL}/legacy/${COUNTRY_CODE}/shop/account/language`,
      {
        language: locale,
      },
      { headers: { Authorization: `Bearer ${access_token}` } }
    );
  } catch (error) {
    console.error(error);
  }
}
